import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Meta from '../../../components/Meta';
import { LinkContainer } from 'react-router-bootstrap';

const HowToGuide = () => {
  return (
    <>
        <Meta>
            title='サイトの使い方について | ふるぷら'
            description='ふるぷらECサイトの使い方について説明するページです。'
            keywords={['ふるぷら', '古着', 'ECサイト', 'ガイド']}
        </Meta>
        <Container className='my-5'>
            <Row className='justify-content-center'>
                <Col xs={12} md={8} lg={5}>
                  <section className='howtoguidetop'>
                    <h1 className="fs-3 mb-4 text-center">サイトの使い方について</h1>
                      <h2 className='fs-5 fw-bold'>プロフィールページの使い方</h2>
                        <p>
                          プロフィールへは、ふるぷら公式ECサイトのサイト上部に位置するサイドバーの👤＞＞【プロフィール】で移動できます。<br />
                          プロフィールページでは、以下の3つを行うことができます。<br />
                          ・ログイン時に利用するメールアドレスの確認・変更<br />
                          ・ログイン時に利用するパスワードの変更<br />
                          ・契約プランの確認と変更・解約<br />
                        </p>
                      <h2 className='fs-5 fw-bold'>お気に入り機能について</h2>
                       <p>
                        ふるぷらでは、商品とショップをそれぞれお気に入り登録することができます。<br />
                        お気に入り登録をすることで、3つの”べんり”を実現できます！<br />
                        <br />
                        <span className='fs-6 fw-bold text-success'>1．気になった服やお店をストック</span><br />
                        『これ可愛い！でも、今レンタルするか迷う...』という時に、お気に入り登録をすれば、後から見返せます！<br />
                        <span className='fs-6 fw-bold text-success'>2．在庫が復活した時にすぐチェックができる</span><br />
                        古着は一点ものであるため、『欲しかったアイテムがレンタル中！』となることもあります。<br />
                        お気に入り登録することで、在庫が戻ったときにすぐ気づけます。<br />
                        <span className='fs-6 fw-bold text-success'>3．購入orレンタルのタイミングを自由に選べる</span><br />
                        『今日はレンタルだけ、でも今度は購入したい！』時は、お気に入りに入れておけば、そのときの気分で自由に選べます。<br />
                       </p>
                      <h2 className='fs-5 fw-bold'>購入履歴・レンタル履歴の確認</h2>
                        <p>
                          注文履歴へは、ふるぷら公式ECサイトのサイト上部に位置するサイドバーの👤＞＞【注文履歴】で移動できます。<br />
                          注文履歴では、<br />
                          ・未支払いの商品<br />
                          ・未受取の商品<br />
                          ・レンタル中の商品<br />
                          ・過去のレンタル・購入・延長のオーダー履歴<br />
                          が確認できます。<br />
                          <br />
                          また、各商品に関する情報も確認できます。<br />
                          ・レンタル期間<br />
                          ・返却期限<br />
                          ・オーダー時に選択した商品の利用方法：サブスク/単発レンタル/購入<br />
                          ・オーダー時に選択した商品の受取方法：配送/お店で受取<br />
                          <br />
                          未受取の商品は、【お店の情報】をクリックすると<span className='fw-bold'>在庫のある店舗名や店舗住所</span>が確認できます。<br />
                          <br />
                          レンタル中の商品は、【確認する】をクリックすると<span className='fw-bold'>在庫のある店舗情報に加え、割引価格での購入やレンタル期間延長の手続き</span>が行えます。
            
                        </p>
                  </section>
                </Col>
            </Row>
        </Container>
    </>
   

  )
}

export default HowToGuide